import React, { useEffect, useState } from "react";

// Lectura en voz alta con la voz del navegador (Web Speech API). No envia nada a ningun servidor.
export const hayVoz = () => typeof window !== "undefined" && "speechSynthesis" in window && typeof window.SpeechSynthesisUtterance !== "undefined";

export const detener = () => { try { if (hayVoz()) window.speechSynthesis.cancel(); } catch (e) { /* sin voz */ } };

const hablar = (texto, alTerminar) => {
    try {
        const s = window.speechSynthesis;
        s.cancel();
        const u = new window.SpeechSynthesisUtterance(texto);
        const voz = (s.getVoices() || []).find(v => /^es(-|_|$)/i.test(v.lang));
        if (voz) u.voice = voz;
        u.lang = (voz && voz.lang) || "es-ES";
        u.rate = 0.95;
        u.onend = alTerminar;
        u.onerror = alTerminar;
        s.speak(u);
        return true;
    } catch (e) { return false; }
};

// Boton «Leer en voz alta»: lee el texto y vuelve a ser «Detener». Se oculta si el navegador no tiene voz. Al cambiar el texto o cerrar, se calla.
export const BotonVoz = ({ texto, className = "btn btn-outline-secondary btn-sm" }) => {
    const [leyendo, setLeyendo] = useState(false);
    useEffect(() => { setLeyendo(false); detener(); return detener; }, [texto]);
    if (!hayVoz()) return null;
    return (
        <button className={`${className} no-imprimir`} aria-pressed={leyendo}
            onClick={() => { if (leyendo) { detener(); setLeyendo(false); } else setLeyendo(hablar(texto, () => setLeyendo(false))); }}>
            <i className={`fa fa-${leyendo ? "stop" : "volume-up"} me-1`} />{leyendo ? "Detener" : "Leer en voz alta"}
        </button>
    );
};
